module.exports = __webpack_public_path__ + "static/Inspire Impact-35d5198fe966ec8625eb733c447c9733.jpg";